$(window).on("load", () => {

});

$(document).ready(() => {
    localStorage.setItem('productsId', '')
    localStorage.setItem('resources', '')
    localStorage.setItem('languages', '')

    $(function() {
        $(".header-search-icon").on("click", function(event) {
            $(".header-search").addClass("searching");
            event.stopPropagation()
        });
        $(document).on("click", function(event) {
            if ($(event.target).is(".search-input") === false) {
                $(".header-search").removeClass("searching");
            }
        });
    });

    $('.download-product__slider').slick(getSliderSettings())

    initCheckbox()
    onMenuClick()
    initFilesPagination()
})

function onMenuClick() {
    document.querySelector(".header-menu-burger")
        .addEventListener('click', () => {
        document.querySelector(".header")
            .classList.toggle('menu_open');
    })
}
function getSliderSettings() {
    return {dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,
        arrows: true,
        prevArrow: `<svg class="arrow next" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.8501 2.9C17.1001 3.15 17.2251 3.446 17.2251 3.788C17.2251 4.12933 17.1001 4.425 16.8501 4.675L9.5251 12L16.8751 19.35C17.1084 19.5833 17.2251 19.875 17.2251 20.225C17.2251 20.575 17.1001 20.875 16.8501 21.125C16.6001 21.375 16.3041 21.5 15.9621 21.5C15.6208 21.5 15.3251 21.375 15.0751 21.125L6.6751 12.7C6.5751 12.6 6.5041 12.4917 6.4621 12.375C6.42076 12.2583 6.4001 12.1333 6.4001 12C6.4001 11.8667 6.42076 11.7417 6.4621 11.625C6.5041 11.5083 6.5751 11.4 6.6751 11.3L15.1001 2.875C15.3334 2.64167 15.6208 2.525 15.9621 2.525C16.3041 2.525 16.6001 2.65 16.8501 2.9Z" fill="#727DA3"/>
        </svg>
        `,
                nextArrow: `<svg class="arrow prev" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.1499 21.1C6.8999 20.85 6.7749 20.554 6.7749 20.212C6.7749 19.8707 6.8999 19.575 7.1499 19.325L14.4749 12L7.1249 4.65C6.89157 4.41667 6.7749 4.125 6.7749 3.775C6.7749 3.425 6.8999 3.125 7.1499 2.875C7.3999 2.625 7.6959 2.5 8.0379 2.5C8.37924 2.5 8.6749 2.625 8.9249 2.875L17.3249 11.3C17.4249 11.4 17.4959 11.5083 17.5379 11.625C17.5792 11.7417 17.5999 11.8667 17.5999 12C17.5999 12.1333 17.5792 12.2583 17.5379 12.375C17.4959 12.4917 17.4249 12.6 17.3249 12.7L8.8999 21.125C8.66657 21.3583 8.37924 21.475 8.0379 21.475C7.6959 21.475 7.3999 21.35 7.1499 21.1Z" fill="#727DA3"/>
        </svg>
        `,}

}
function initCheckbox() {
    const grabAndSend = () => {
        let categories = [];
        let languages = [];
        let resources =[];
        document
            .querySelectorAll('.categories')
            .forEach((input) => {
                if (!input.checked) {
                    return;
                }
                categories.push(input.getAttribute('value'))
            })
        document
            .querySelectorAll('.resources')
            .forEach((input) => {
                if (!input.checked) {
                    return;
                }
                resources.push(input.getAttribute('value'))
            })
        localStorage.setItem('resources', resources.join(','));
        document
            .querySelectorAll('.languages')
            .forEach((input) => {
                if (!input.checked) {
                    return;
                }
                languages.push(input.getAttribute('value'))
            })
        localStorage.setItem('languages', languages.join(','));

        const productId = localStorage.getItem('productsId')

        $.ajax({
            url: '/api/v1/search?categories=' + categories.join(',') + '&languages=' + languages.join(',') + '&resources=' + resources.join(',') + '&active_product=' + productId,
            headers: {'Accept': 'application/json'},
            success: function ({data}) {
                const {products, files} = data

                document.getElementById('products').innerHTML = products
                document.getElementById('files').innerHTML = files
                $('.download-product__slider').slick(getSliderSettings());
            },
            cache: false,
            contentType: false,
            processData: false
        })
    }

    document
        .querySelectorAll('.toggle-input')
        .forEach((input) => {
            input.onclick = grabAndSend
        })
}

function initFilesPagination() {
    let forPagination = {
        products: "",
        page: 1
    };

    const setProduct = (event, id) => {
        forPagination.products = id
        event.target.classList.add("download-product__item-link-active")
        localStorage.setItem('productsId', forPagination.products);
    }

    const removeProduct = () => {
        forPagination.products = "";
        localStorage.setItem('productsId', forPagination.products);
    }

    const removeClass = () => {
        document.querySelector(`[data-id="${forPagination.products}"]`)
            .classList.remove("download-product__item-link-active")
    }

    $(document).on('click', '.product-link', (event) => {
        event.preventDefault()
        forPagination.page=1

        let newProductId = Number(event.target.dataset.id)
        if (forPagination.products === ""){
            setProduct(event, newProductId)
        } else if(forPagination.products !== newProductId) {
            removeClass()
            setProduct(event, newProductId)
        } else if(forPagination.products !== "" && forPagination.products === newProductId) {
            removeClass()
            removeProduct()
        }
        fetchPagination(forPagination)
    })

    $(document).on('click', '.pagination-item', (event) => {
        event.preventDefault()
        console.log(event.target)
        let paginationPage = Number(event.target.dataset.page)
        let productsIds = localStorage.getItem('productsId')
        forPagination.page = paginationPage;
        if (productsIds === null || productsIds === ""){
            document
                .querySelectorAll('.download-product__item')
                .forEach((input) => {
                    forPagination.products += input.getAttribute('data-product-id') + ','
                })
        }

        forPagination.products = productsIds ? productsIds : forPagination.products;
        fetchPagination(forPagination)
        forPagination.products = "";
    })


    function fetchPagination(forPagination) {
        $.ajax({
            url: '/api/v1/search/files?products=' + forPagination.products + '&page=' + forPagination.page + '&languages=' + localStorage.getItem('languages') + '&resources=' + localStorage.getItem('resources'),
            headers: {'Accept': 'application/json'},
            success: function ({data}) {
                document.getElementById('files').innerHTML = data.files
            },
            cache: false,
            contentType: false,
            processData: false
        })
    }
}
